/**
 * Invite Codes API
 */
import axios from 'axios'
import { apiClient } from './client'
import { config } from '../config'
import type { InviteCode, InviteCodeCreate, SignupRequest, SignupResponse } from '../types'

const ADMIN_BASE_PATH = '/api/admin/invite-codes'
const SIGNUP_PATH = '/api/signup'

// Public client for signup (no auth required)
const publicClient = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const invitesApi = {
  // ===== Admin endpoints (requires authentication) =====

  list: async (tenantId?: string): Promise<InviteCode[]> => {
    const params = tenantId ? { tenant_id: tenantId } : {}
    const response = await apiClient.get<InviteCode[]>(ADMIN_BASE_PATH, { params })
    return response.data
  },

  create: async (data: InviteCodeCreate): Promise<InviteCode> => {
    const response = await apiClient.post<InviteCode>(ADMIN_BASE_PATH, data)
    return response.data
  },

  revoke: async (codeId: string): Promise<void> => {
    await apiClient.delete(`${ADMIN_BASE_PATH}/${codeId}`)
  },

  // ===== Public endpoints (no authentication) =====

  signup: async (data: SignupRequest): Promise<SignupResponse> => {
    const response = await publicClient.post<SignupResponse>(SIGNUP_PATH, data)
    return response.data
  },
}
